import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, HashRouter } from 'react-router-dom'
import { AuthProvider } from '@/auth/AuthProvider'
import { PreferencesProvider } from '@/ui/preferences'
import { DatasetProvider } from '@/data/DatasetProvider'
import { ViewAsBanner } from '@/components/ViewAs'
import { DevModeProvider } from '@/ui/devMode'
import { App } from './App'
import './styles/tokens.css'
import './styles/base.css'
import './styles/rules.css'
import '@focalpointcare/review-drawer/styles.css'

/*
 * A demo build is published under some other path (a review URL, a static host), where
 * a path-based router matches none of its routes and renders a blank page. The hash
 * router works wherever the file is served from. The real app keeps clean URLs.
 */
const Router = import.meta.env.VITE_DEMO === '1' ? HashRouter : BrowserRouter

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Router>
      <PreferencesProvider>
        <AuthProvider>
          <DevModeProvider>
            <DatasetProvider>
              {/* Outside every gate, so Exit is there even if the view failed to load. */}
              <ViewAsBanner />
              <App />
            </DatasetProvider>
          </DevModeProvider>
        </AuthProvider>
      </PreferencesProvider>
    </Router>
  </StrictMode>,
)
